import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'


const cache = {
  // 设置缓存
  set(key, data, expireTime = 360 * 60 * 1000) {
    const cacheData = {
      data,
      expireTime: Date.now() + expireTime,
      timestamp: Date.now()
    }
    localStorage.setItem(key, JSON.stringify(cacheData))
  },
  // 获取缓存
  get(key) {
    const cacheStr = localStorage.getItem(key)
    if (!cacheStr) return null
    try {
      const cacheData = JSON.parse(cacheStr)
      // 检查是否过期
      if (Date.now() > cacheData.expireTime) {
        this.remove(key) // 过期就删除
        return null
      } 
      return cacheData.data
    } catch (error) {
      console.error('缓存数据解析失败:', error)
      this.remove(key)
      return null
    }
  },
  // 删除缓存
  remove(key) {
    localStorage.removeItem(key)
  },
  // 新增：获取剩余时间（毫秒）
  remainingTime(key) {
    const cacheStr = localStorage.getItem(key)
    if (!cacheStr) return 0
    
    try {
      const cacheData = JSON.parse(cacheStr)
      const now = Date.now()
      
      // 如果已过期，返回0并删除
      if (now > cacheData.expireTime) {
        this.remove(key)
        return 0
      }
      
      // 返回剩余时间（毫秒）
      return cacheData.expireTime - now
    } catch (error) {
      console.error('缓存数据解析失败:', error)
      this.remove(key)
      return 0
    }
  }
}

export { cache }


export function clearStorage() {
  // 要排除的key
  const excludeKeys = ['auth_redirect']
  
  // 获取所有localStorage的key
  const keys = Object.keys(localStorage)
  
  // 遍历删除
  keys.forEach(key => {
    if (!excludeKeys.includes(key)) {
      localStorage.removeItem(key)
    }
  })
}

export function rrr (start, end) {
  return Math.round(Math.random() * end + start)
}


export function nowDate (t) {
  const nwdt = new Date()
  
  // 统一处理日期格式的函数
  const formatDate = (date, separator = '-') => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    if (separator === '') {
      return `${year}${month}${day}`
    }
    return `${year}${separator}${month}${separator}${day}`
  }
  
  const emillistr = '000' + nwdt.getMilliseconds()
  const n = {
    eyear: nwdt.getFullYear(),
    emouth: String(nwdt.getMonth() + 1).padStart(2, '0'),
    edate: String(nwdt.getDate()).padStart(2, '0'),
    ehours: String(nwdt.getHours()).padStart(2, '0'),
    eminutes: String(nwdt.getMinutes()).padStart(2, '0'),
    eseconds: String(nwdt.getSeconds()).padStart(2, '0'),
    emilliseconds: emillistr.slice(-3)
  }
  
  const ndate = `${n.eyear}-${n.emouth}-${n.edate}`
  const ndate2 = `${n.eyear}${n.emouth}${n.edate}`
  const ndatet = `${ndate} ${n.ehours}:${n.eminutes}:${n.eseconds}`
  const ndatetstr = `${ndate2}${n.ehours}${n.eminutes}${n.eseconds}${n.emilliseconds}`
  
  // 昨天日期
  const yesterday = new Date(nwdt)
  yesterday.setDate(yesterday.getDate() - 1)
  const ydate = formatDate(yesterday, '-')     // 2026-05-05
  const ydate2 = formatDate(yesterday, '')     // 20260505
  
  // 十天前日期
  const tenDaysAgo = new Date(nwdt)
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10)
  const wdate = formatDate(tenDaysAgo, '-')    // 2026-04-25
  const wdate2 = formatDate(tenDaysAgo, '')    // 20260425（如有需要可扩展）

  const dateMap = {
    0: ndate,           // 当天 YYYY-MM-DD
    1: ndatet,          // 当天 YYYY-MM-DD HH:MM:SS
    2: ndatetstr,       // 当天 时间戳字符串
    3: ndate2,          // 当天 YYYYMMDD
    4: ydate,           // 昨天 YYYY-MM-DD
    5: ydate2,          // 昨天 YYYYMMDD
    6: wdate,           // 10天前 YYYY-MM-DD
    7: wdate2,          // 10天前 YYYYMMDD
    11: `${n.eyear}-01-01`,  // 年初
    12: `${n.eyear}-${n.emouth}-01`,  // 月初
    100: `${n.eyear}-12-31`,  // 年底
    1000: n.eyear       // 年
  }
  
  return dateMap[t] || ''
}

// 辅助函数：计算两个日期字符串之间的天数差
export function daysdRange (startDateStr, endDateStr) {
  const startDate = new Date(startDateStr)
  const endDate = new Date(endDateStr)
  const timeDiff = Math.abs(endDate.getTime() - startDate.getTime())
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24))
}

export function strtodate (str) {
  if (str === 'nowdate') {
    return nowDate(0)
  } else if (str === 'nowdatetime') {
    return nowDate(1)
  } else {
    return str
  }
}

export function strtodate2 (str) {
  if (str === 'nowdate') {
    return [nowDate(0), nowDate(0)]
  } else if (str === 'nowdatetime') {
    return [nowDate(1), nowDate(1)]
  } else {
    return [str, str]
  }
}

export function strtoselect (str) {
  var rt = []
  if (str !== '') {
    rt = str.split(',')
  }
  return rt
}

export function strtolst (str) {
  var rt = []
  if (str === '' || str.indexOf('=') < 0) {
    return rt
  }
  var str0 = []
  str0 = str.split(';')
  for (var i = 0; i < str0.length; i++) {
    var rt0 = {}
    var str00 = []
    str00 = str0[i].split(',')
    for (var j = 0; j < str00.length; j++) {
      var str000 = []
      str000 = str00[j].split('=')
      rt0[str000[0]] = str000[1]
    }
    rt.push(rt0)
  }
  return rt
}

export function strtoboolean (str) {
  if (str === 'true') {
    return true
  } else {
    return false
  }
}

export function loginstr (str) {
  if (str === 'loginuser') {
    return localStorage.getItem('loginuser')
  } else {
    return str
  }
}

export function rewheres (arr, lst) {
  let s = []
  let tin = false
  for (var key in arr) {
    for (var i = 0; i < lst.length; i++) {
      if (key === lst[i]['fname']) {
        if (lst[i]['ftype'] === 'datepickers') {
          s.push(arr[key][0])
          s.push(arr[key][1])
        } else if (lst[i]['ftype'] === 'datepicker2') {
          s.push(arr[key])
          s.push(arr[key])
        } else {
          s.push(arr[key])
        }
        tin = true
        break
      } else {
        tin = false
      }
    }
    // for循环结束，没有找到的话直接添加
    if (tin === false) {
      s.push(arr[key])
    }
  }
  return s
}

export function xyz (otstr) {
  var rt = {}
  if (otstr.length > 0) {
    let ot = JSON.parse(otstr)
    for (let e in ot) {
      if (ot[e]['type'] === 5) {
        rt = ot[e]['value']
      }
    }
    return rt
  } else {
    return {}
  }
}

export function totalCalcula (data, total, filters = {}) {
  const filteredData = data.filter(item => {
    for (const [field, filterValue] of Object.entries(filters)) {
      if (filterValue !== null && filterValue !== undefined) {
        if (item[field] !== filterValue) {
          return false
        }
      }
    }
    return true
  })
  let totalvalue = filteredData.reduce(
    (s, k) => s + Number(k[total] || 0), 0
  )
  return totalvalue.toFixed(2)
}

// 分组函数
export function groupCalcula (
  data,
  group,
  value,
  filters = {},
  unit=10000,
  teamField='label',
  totalField='value',
  sortField=teamField,
  sortOrder='asc'
) {
  const map = new Map()

  data.forEach(item => {
    // 多条件过滤检查
    let shouldSkip = false  
    // 遍历所有过滤条件
    for (const [field, filterValue] of Object.entries(filters)) {
      if (filterValue !== null && filterValue !== undefined) {
        if (item[field] !== filterValue) {
          shouldSkip = true
          break
        }
      }
    }
    if (shouldSkip) {
      return
    }

    const groupValue = item[group]
    const amount = Number(item[value] || 0) / unit
    
    if (map.has(groupValue)) {
      map.get(groupValue)[totalField] += amount
    } else {
      map.set(groupValue, { 
        [teamField]: groupValue, 
        [totalField]: amount 
      })
    }
  })
  
  // 格式化数字，保留两位小数
  let result = Array.from(map.values()).map(item => ({
    ...item,
    [totalField]: Number(item[totalField].toFixed(2))
  }))
  
  // 动态排序
  if (sortField) {
    result = result.sort((a, b) => {
      const aValue = a[sortField]
      const bValue = b[sortField]
      
      // 数字类型排序
      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortOrder === 'desc' ? bValue - aValue : aValue - bValue
      }
      
      // 字符串类型排序
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortOrder === 'desc' 
          ? bValue.localeCompare(aValue) 
          : aValue.localeCompare(bValue)
      }
      
      // 混合类型或其它情况，转为字符串比较
      return sortOrder === 'desc' 
        ? String(bValue).localeCompare(String(aValue))
        : String(aValue).localeCompare(String(bValue))
    })
  }
  
  return result
}


export function calculateRate(actualValue, referenceValue, type='yoy') {
  // 转换为数字，处理 null、undefined、字符串等情况
  const actual = parseFloat(actualValue) || 0;
  const reference = parseFloat(referenceValue) || 0;
  // 验证计算类型
  if (type !== 'completion' && type !== 'yoy') {
      return NaN; // 返回 NaN 表示参数错误
  }
  // 处理分母为0的情况
  if (reference === 0) {
      if (actual === 0) {
          return 0; // 都为0时返回0
      } else if (actual > 0) {
          return type === 'completion' ? Infinity : Infinity; // 正无穷
      } else {
          return type === 'completion' ? 0 : -Infinity; // 负无穷
      }
  }
  let result;
  switch (type) {
      case 'completion':
          // 完成率 = 实际值 / 计划值
          result = (actual / reference) * 100;
          return parseFloat(result.toFixed(2)); // 转换为数字
          
      case 'yoy':
          // 同比 = (本期值 - 同期值) / 同期值
          result = ((actual - reference) / reference) * 100;
          return parseFloat(result.toFixed(2)); // 转换为数字
  }
}

/**
 * 图表数据处理函数 - 将实际数据和相关数据对齐，计算完成率或同比率，整理为图表可用格式
 * @param {Array<{label: string, value: number}>} actualData - 实际数据数组，每个元素包含label（组别名称）和value（数值）
 * @param {Array<{label: string, value: number}>} correlateData - 相关数据数组，结构同actualData
 *                                                     完成率模式时为计划数据，同比模式时为去年同期数据
 * @param {'completion' | 'yoy'} [calculationType='completion'] - 计算公式类型
 *                                                               'completion': 完成率公式，(实际值/计划值)×100%
 *                                                               'yoy': 同比公式，((本期-去年同期)/去年同期)×100%
 * @returns {Object} 处理后的数据对象，包含以下字段：
 *                  - categories: string[] - 排序后的组别名称数组
 *                  - actualValues: number[] - 实际数值数组
 *                  - correlateValues: number[] - 相关数值数组
 *                  - completionRates?: number[] - 完成率数组（当calculationType='completion'时）
 *                  - yoyRates?: number[] - 同比增长率数组（当calculationType='yoy'时）
 * @example
 * // 计算完成率示例
 * const result = processChartData(
 *   [{label: '部门A', value: 150}, {label: '部门B', value: 200}],
 *   [{label: '部门A', value: 100}, {label: '部门C', value: 300}],
 *   'completion'
 * );
 * // 返回: {categories: ['部门A','部门B','部门C'], actualValues: [150,200,0], 
 * //       correlateValues: [100,0,300], completionRates: [150,100,0]}
 */
export function processChartData(actualData, correlateData, calculationType = 'completion') {
  // calculationType: 'completion' - 完成率公式 | 'yoy' - 同比公式
  if (!actualData || !correlateData) {
    console.error('数据为空:', { actualData, correlateData });
    return {
      categories: [],
      actualValues: [],
      correlateValues: [],
      rateValues: []
    };
  }
  
  // 获取所有组别的并集
  const allGroupsSet = new Set();
  
  // 收集实际数据中的所有组别（过滤掉null或undefined）
  actualData.forEach(item => {
    if (item && item.label) {
      allGroupsSet.add(item.label);
    }
  });
  
  // 收集计划数据中的所有组别（过滤掉null或undefined）
  correlateData.forEach(item => {
    if (item && item.label) {
      allGroupsSet.add(item.label);
    }
  });
  
  // 将Set转换为数组并过滤有效值，然后按汉字排序
  const allGroups = Array.from(allGroupsSet)
    .filter(group => group != null) // 过滤掉null和undefined
    .sort((a, b) => {
      // 使用localeCompare进行中文排序，添加空值保护
      if (a == null || b == null) return 0;
      return a.localeCompare(b, 'zh-CN');
    });
  
  // 创建映射对象便于查找
  const actualMap = {};
  const correlateMap = {};
  
  actualData.forEach(item => {
    if (item && item.label != null) {
      actualMap[item.label] = item.value || 0;
    }
  });
  
  correlateData.forEach(item => {
    if (item && item.label != null) {
      correlateMap[item.label] = item.value || 0;
    }
  });
  
  // 按统一顺序整理数据
  const categories = [];
  const actualValues = [];
  const correlateValues = [];
  const rateValues = []; // 通用：完成率或同比率数组
  
  allGroups.forEach(group => {
    const actual = actualMap[group] || 0;
    const correlate = correlateMap[group] || 0;
    
    categories.push(group);
    actualValues.push(actual);
    correlateValues.push(correlate);
    
    // 根据公式类型计算不同的比率
    let rateValue = 0;
    
    if (calculationType === 'completion') {
      // 完成率计算公式
      if (correlate > 0) {
        rateValue = Number(((actual / correlate) * 100).toFixed(2));
      } else if (actual > 0) {
        // 如果计划为0但实际有值，完成率设为100%
        rateValue = 100.00;
      }
    } else if (calculationType === 'yoy') {
      // 同比计算公式：((本期-去年同期)/去年同期)×100%
      if (correlate !== 0 && actual !== 0) {
        rateValue = Number((((actual - correlate) / correlate) * 100).toFixed(2));
      }
      if (correlate === 0 && actual !== 0) {
        // 如果去年同期为0但本期有值，同比设为100%
        rateValue = 100.00;
      }
      if (correlate !== 0 && actual === 0) {
        // 如果本期为0但去年同期有值，同比设为-100%
        rateValue = -100.00;
      }
      if (correlate === 0 && actual === 0) {
        rateValue = 0;
      }
    }
    
    rateValues.push(rateValue);
  });
 
  // 根据公式类型返回不同的字段名
  const result = {
    categories,
    actualValues,
    correlateValues
  };
  
  if (calculationType === 'completion') {
    result.completionRates = rateValues;
  } else if (calculationType === 'yoy') {
    result.yoyRates = rateValues; // 同比率
  }
  return result;
}


/**
 * 按指定字段对数据进行排序并截取前N个
 * @param {Object} data 原始数据对象，包含多个相同长度的数组
 * @param {string} sortBy 排序依据的字段名
 * @param {number} limit 截取的数量
 * @param {string} direction 排序方向：'asc' 升序 / 'desc' 降序
 * @returns {Object} 排序并截取后的数据对象
 */
export const sortAndLimitData = (data, sortBy, limit = 10, direction = 'desc') => {
  // 参数校验
  if (!data || typeof data !== 'object') {
    console.error('sortAndLimitData: 数据格式错误')
    return data
  }
  
  if (!Array.isArray(data[sortBy])) {
    console.error(`sortAndLimitData: 排序字段 "${sortBy}" 不存在或不是数组`)
    return data
  }
  
  // 获取数据长度
  const dataLength = data[sortBy].length
  
  // 验证所有数组长度是否一致
  const keys = Object.keys(data)
  for (const key of keys) {
    if (Array.isArray(data[key]) && data[key].length !== dataLength) {
      console.error(`sortAndLimitData: 数组 "${key}" 长度不一致`)
      return data
    }
  }
  
  // 创建索引数组
  let indices = Array.from({ length: dataLength }, (_, i) => i)
  
  // 按指定字段排序索引
  const sortArray = data[sortBy]
  indices.sort((a, b) => {
    const valueA = sortArray[a]
    const valueB = sortArray[b]
    
    // 处理null或undefined
    if (valueA == null) return direction === 'asc' ? -1 : 1
    if (valueB == null) return direction === 'asc' ? 1 : -1
    
    // 数值比较
    if (direction === 'desc') {
      return valueB - valueA  // 降序
    } else {
      return valueA - valueB  // 升序
    }
  })
  
  // 截取前N个索引
  const limitedIndices = indices.slice(0, limit)
  
  // 构建结果对象
  const result = {}
  
  for (const key of keys) {
    if (Array.isArray(data[key])) {
      // 对数组类型的数据按排序后的索引重新排列
      result[key] = limitedIndices.map(index => data[key][index])
    } else {
      // 非数组类型的数据直接复制
      result[key] = data[key]
    }
  }
  
  return result
}


/**
 * 数据处理函数 - 按指定维度汇总并计算比率和合计
 * @param {Array} originalData - 原始数据
 * @param {Array} groupByFields - 分组字段列表，如 ['deptn', 'customern', 'brandn']
 * @param {Array} sumFields - 需要求和的数值字段列表，如 ['saleamount', 'planamount', 'theamount']
 * @param {Object[]} sortConfig - 排序规则数组
 * @param {string} sortConfig[].field - 排序字段
 * @param {string} sortConfig[].order - 排序顺序 'asc' 或 'desc' 
 * 如：[{field: 'name', order: 'asc'}, {field: 'age', order: 'desc'}]
 * @param {Object} ratioConfig - 计算配置
 * @param {boolean} showTotal - 是否显示合计行
 * @param {boolean} formatOutput - 是否格式化输出（千分位、百分比）
 * @returns {Array} 处理后的数据
 */
export function calcStandard(originalData, groupByFields, sumFields,
  sortConfig = [], ratioConfig = {}, showTotal = true,formatOutput = true) {

  if (!originalData || !originalData.length) return []

  const config = ratioConfig;

  // 1. 按指定字段分组汇总
  const summaryMap = new Map();
  const totalRow = createEmptyTotalRow(sumFields);
  
  originalData.forEach(item => {
    // 生成分组key
    const key = groupByFields.map(field => item[field] || '').join('|');
    
    if (!summaryMap.has(key)) {
      const newItem = { ...item };
      // 初始化求和字段
      sumFields.forEach(field => {
        newItem[field] = convertToNumber(item[field]);
      });
      summaryMap.set(key, newItem);
    } else {
      const existing = summaryMap.get(key);
      // 累加数值字段
      sumFields.forEach(field => {
        existing[field] += convertToNumber(item[field]);
      });
    }
    
    // 累计总计行
    sumFields.forEach(field => {
      totalRow[field] += convertToNumber(item[field]);
    });
  });
  
  // 2. 转换为数组并计算比率
  let result = Array.from(summaryMap.values()).map(item => {
    return calculateRatios(item, config, sumFields, formatOutput);
  });
  
  // 3. 添加排序功能
  if (sortConfig && Array.isArray(sortConfig)) {
    result = sortData(result, sortConfig);
  }
  
  // 4. 添加合计行
  if (showTotal && result.length > 0) {
    const totalWithRatios = calculateRatios(totalRow, config, sumFields, formatOutput);
    // 标记合计行
    totalWithRatios.isTotal = true;
    groupByFields.forEach((field, index) => {
      if (index === 0) {
        totalWithRatios[field] = '合计';
      } else {
          totalWithRatios[field] = ''; // 其他分组字段显示空白
      }
    });
    result.push(totalWithRatios);
  }
  
  return result;
}

/**
 * 数据排序函数 - 支持多字段排序
 * @param {Array} data - 要排序的数据
 * @param {Array} sortConfig - 排序配置数组
 * @param {Object[]} sortConfig - 排序规则数组
 * @param {string} sortConfig[].field - 排序字段
 * @param {string} sortConfig[].order - 排序顺序 'asc' 或 'desc'
 * 如：[{field: 'name', order: 'asc'}, {field: 'age', order: 'desc'}]
 * @returns {Array} 排序后的数据
 */
export function sortData(data, sortConfig) {
  // 检查参数有效性
  if (!Array.isArray(sortConfig) || sortConfig.length === 0) {
    return [...data]; // 返回浅拷贝的数据
  }
  
  // 验证配置格式
  const validSortRules = sortConfig.filter(rule => 
    rule && typeof rule === 'object' && rule.field && 
    (rule.order === 'asc' || rule.order === 'desc')
  );
  
  if (validSortRules.length === 0) {
    return [...data];
  }
  
  // 执行多字段排序
  return [...data].sort((a, b) => {
    for (let i = 0; i < validSortRules.length; i++) {
      const rule = validSortRules[i];
      let valueA = a[rule.field];
      let valueB = b[rule.field];
      
      // 处理格式化数值（去除千分位逗号）
      if (typeof valueA === 'string' && valueA.includes(',')) {
        valueA = convertToNumber(valueA);
        valueB = convertToNumber(valueB);
      }
      
      // 处理百分比数值
      if (typeof valueA === 'string' && valueA.includes('%')) {
        valueA = convertPercentageToNumber(valueA);
        valueB = convertPercentageToNumber(valueB);
      }
      
      // 处理null或undefined（空值排在最后）
      const isValueANull = valueA == null || valueA === '';
      const isValueBNull = valueB == null || valueB === '';
      
      if (isValueANull && !isValueBNull) {
        return rule.order === 'asc' ? 1 : -1;
      }
      if (!isValueANull && isValueBNull) {
        return rule.order === 'asc' ? -1 : 1;
      }
      if (isValueANull && isValueBNull) {
        continue; // 都为空，继续比较下一个字段
      }
      
      // 比较当前字段
      if (valueA === valueB) {
        // 如果相等，继续比较下一个字段
        continue;
      }
      
      // 确定比较结果
      let comparison = 0;
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        comparison = valueA - valueB;
      } else {
        comparison = String(valueA).localeCompare(String(valueB));
      }
      
      // 根据排序方向调整结果
      if (rule.order === 'desc') {
        comparison = -comparison;
      }
      
      return comparison;
    }
    
    // 所有排序字段都相等
    return 0;
  });
}

/**
 * 将百分比字符串转换为数值
 */
export function convertPercentageToNumber(percentageStr) {
  if (!percentageStr || typeof percentageStr !== 'string') return 0;
  const cleaned = percentageStr.replace('%', '').trim();
  return parseFloat(cleaned) || 0;
}

/**
 * 创建空的合计行
 */
export function createEmptyTotalRow(sumFields) {
  const totalRow = {};
  sumFields.forEach(field => {
    totalRow[field] = 0;
  });
  return totalRow;
}

/**
 * 简单计算字段
 */
export function calculateRatios(item, ratioConfig, sumFields, formatOutput = true) {
  const result = { ...item };
  
  Object.keys(ratioConfig).forEach(ratioField => {
    const config = ratioConfig[ratioField];
    // 跳过 null 或 undefined 的配置
    if (config === null || config === undefined) {
      return;
    }
    const numerator = result[config.numerator] || 0;
    let denominator = result[config.denominator] || 0;
    
    let ratioValue = 0;

    let isPercentage = true; // 默认按百分比输出
    
    // 两列相加
    if (config.isAdd) {
      ratioValue = numerator + (denominator || 0);
      isPercentage = false;
    }
    // 两列相减
    else if (config.isSubtract) {
      ratioValue = numerator - (denominator || 0);
      isPercentage = false;
    }
    // 两列相乘
    else if (config.isMultiply) {
      ratioValue = numerator * (denominator || 0);
      isPercentage = false;
    }
    // 两列相除
    else if (config.isDivide) {
      if (denominator !== 0) {
        ratioValue = numerator / denominator;
        // 除法结果可以控制是否显示为百分比
        isPercentage = config.isPercent !== false;
      } else {
        ratioValue = 0;
        isPercentage = config.isPercent !== false;
      }
    }
    // 毛利率公式
    else if (config.isGrossProfit && numerator !== 0) {
      ratioValue = ((numerator - denominator) / numerator) * 100;
      isPercentage = true;
    }
    // 增长率计算
    else if (config.isGrowth && denominator !== 0) {
      denominator = result[config.denominator];
      ratioValue = ((numerator - denominator) / denominator) * 100;
      isPercentage = true;
    } 
    // 普通比率计算
    else if (denominator !== 0) {
      ratioValue = (numerator / denominator) * 100;
      isPercentage = true;
    }
    
    // 根据格式化选项处理输出
    if (formatOutput) {
      if (isPercentage) {
        result[ratioField] = formatPercentage(ratioValue);
      } else {
        result[ratioField] = formatNumber(ratioValue);
      }
      
      // 为同比小于0的值添加特殊标记（用于前端样式）
      if (ratioField === 'YoY' && ratioValue < 0) {
        result.isNegativeGrowth = true;
      }
    } else {
      result[ratioField] = Math.round(ratioValue * 100) / 100;
      
      // 为同比小于0的值添加特殊标记
      if (ratioField === 'YoY' && ratioValue < 0) {
        result.isNegativeGrowth = true;
      }
    }
  });
  
  // 格式化数值字段
  sumFields.forEach(field => {
    if (result[field] !== undefined) {
      if (formatOutput) {
        result[field] = formatNumber(result[field]);
      } else {
        result[field] = Math.round(result[field] * 100) / 100;
      }
    }
  });
  
  return result;
}

/**
 * 安全的数值转换（内部计算使用，不格式化）
 */
export function convertToNumber(value) {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const cleaned = value.replace(/,/g, '').trim();
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }
  return 0;
}

/**
 * 数值格式化函数 - 千分位分隔
 */
export function formatNumber(num) {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }

  const numberValue = Number(num);
  if (isNaN(numberValue)) {
    return '0';
  }

  const fixedValue = Number(numberValue.toFixed(2));
  return fixedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * 百分比格式化函数
 */
export function formatPercentage(value) {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.00%';
  }

  const numberValue = Number(value);
  if (isNaN(numberValue)) {
    return '0.00%';
  }

  return numberValue.toFixed(2) + '%';
}

/**
 * 解析格式化数字（移除千分位逗号）
 * @param {string} str - 格式化字符串，如 "1,234.56"
 * @returns {number} 数字
 */
export function parseNumber(str) {
  if (!str || typeof str !== 'string') {
    return 0;
  }
  
  const number = parseFloat(str.replace(/,/g, ''));
  return isNaN(number) ? 0 : number;
}

/**
 * 解析百分比字符串
 * @param {string} str - 百分比字符串，如 "12.34%"
 * @returns {number} 小数（如 0.1234）
 */
export function parsePercent(str) {
  if (!str || typeof str !== 'string') {
    return 0;
  }
  
  const number = parseFloat(str.replace(/%/g, '').replace(/,/g, '')) / 100;
  return isNaN(number) ? 0 : number;
}

/**
 * 解析表格数据中的格式化数值
 * @param {Array} tableData - 表格数据数组
 * @param {Array} numberColumns - 数字列名数组（需要移除千分位）
 * @param {Array} percentColumns - 百分比列名数组（需要解析为小数）
 * @returns {Array} 处理后的数据
 */
export function parseTableData(tableData, numberColumns = [], percentColumns = []) {
  if (!Array.isArray(tableData)) return [];
  
  return tableData.map(item => {
    const parsedItem = { ...item };
    
    // 处理数字列
    numberColumns.forEach(col => {
      if (parsedItem[col] && typeof parsedItem[col] === 'string') {
        parsedItem[col] = parseNumber(parsedItem[col]);
      }
    });
    
    // 处理百分比列
    percentColumns.forEach(col => {
      if (parsedItem[col] && typeof parsedItem[col] === 'string') {
        parsedItem[col] = parsePercent(parsedItem[col]);
      }
    });
    
    return parsedItem;
  });
}


/**
 * 通用Excel导出函数
 * @param {Array} data - 要导出的数据数组
 * @param {Array} headers - Excel表头数组
 * @param {String} fileName - 导出文件名
 * @param {String} sheetName - 工作表名称，默认为'Sheet1'
 * @param {String} messageInstance - Vue消息实例，可选
 * @returns {Boolean} 导出是否成功
 */
export function exportToExcel({
  data,
  headers = [],
  fileName = '导出数据',
  sheetName = 'Sheet1',
  messageInstance = null} = {}) {
  // 检查数据是否为空
  if (!data || data.length === 0) {
    if (messageInstance) {
      messageInstance.warning('没有数据可导出')
    }
    return false
  }

  try {
    // 创建工作表
    const worksheet = XLSX.utils.json_to_sheet(data)
    
    // 如果有自定义表头，替换默认表头
    if (headers && headers.length > 0) {
      headers.forEach((header, index) => {
        const colLetter = XLSX.utils.encode_col(index) // 0->A, 1->B, 2->C...
        const cellAddress = `${colLetter}1` // A1, B1, C1...
        
        // 确保单元格存在
        if (!worksheet[cellAddress]) {
          worksheet[cellAddress] = {}
        }
        worksheet[cellAddress].v = header
      })
    }
    
    // 创建工作簿
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)
    
    // 生成Excel文件
    const excelBuffer = XLSX.write(workbook, { 
      bookType: 'xls', 
      type: 'array' 
    })
    
    // 创建Blob并保存
    const blobData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    
    saveAs(blobData, `${fileName}.xls`)
    
    // 显示成功消息
    if (messageInstance) {
      messageInstance.success('导出成功')
    }
    
    return true
    
  } catch (error) {
    console.error('导出错误:', error)
    
    if (messageInstance) {
      messageInstance.error('导出失败')
    }
    
    return false
  }
}

/**
 * 简单表格合计函数
 * @param {Object} param - 表格参数 { columns, data }
 * @param {Array} sumIndexes - 需要求和的列索引数组，如 [12, 13, 14]
 * @returns {Array} 合计行数据
 */
export const setTableSummaries = (param, sumColumns = []) => {
  const { columns = [], data = [] } = param || {};
  const sums = new Array(columns.length).fill('');
  
  // 设置第一列为"合计"
  if (sums.length > 0) {
    sums[0] = '合计';
  }
  
  if (data.length === 0 || sumColumns.length === 0) {
    return sums;
  }
  
  // 遍历需要求和的列
  sumColumns.forEach(colConfig => {
    // 支持两种配置方式：
    // 1. 简单数组：[12, 13, 14] - 按索引求和
    // 2. 对象数组：[{index: 12, prop: 'salesquantity'}] - 按属性名求和
    
    let index, prop;
    
    if (typeof colConfig === 'number') {
      // 数字索引方式
      index = colConfig;
      // 尝试从columns获取属性名
      prop = columns[index]?.property;
    } else if (colConfig && typeof colConfig === 'object') {
      // 对象配置方式
      index = colConfig.index;
      prop = colConfig.prop;
    } else {
      return; // 跳过无效配置
    }
    
    // 验证索引范围
    if (index < 0 || index >= sums.length || !prop) {
      return;
    }
    
    try {
      const sum = data.reduce((total, item) => {
        const value = item[prop];
        return total + (Number(value) || 0);
      }, 0);
      
      sums[index] = sum.toFixed(2);
    } catch (error) {
      console.warn(`计算列 ${prop} 合计失败:`, error);
      sums[index] = '';
    }
  });
  
  return sums;
}

/**
 * 创建智能合并函数
 * @param {Array} tableData - 表格数据
 * @param {Array} options - 合并字段
 *   如：['deptn', 'group'] 指定要合并的字段
 * @returns {Function} - 返回 span-method 函数
 */
export function setSpanMethod(tableData, mergeFields = []) {
  // 空数据处理
  if (!tableData?.length || !mergeFields?.length) {
    return () => ({ rowspan: 1, colspan: 1 });
  }

  // 预计算每个字段的合并信息
  const mergeInfo = {};
  
  mergeFields.forEach(field => {
    const fieldValues = tableData.map(item => item[field]);
    const rowspans = new Array(tableData.length).fill(0);
    
    for (let i = 0; i < fieldValues.length; i++) {
      if (rowspans[i] === 0) {
        let rowspan = 1;
        
        // 向后查找相同的值
        for (let j = i + 1; j < fieldValues.length; j++) {
          if (fieldValues[j] === fieldValues[i]) {
            rowspan++;
          } else {
            break;
          }
        }
        
        // 设置合并信息
        rowspans[i] = rowspan;
        // 后面的相同行设置为 -1 表示需要隐藏
        for (let k = 1; k < rowspan; k++) {
          rowspans[i + k] = -1;
        }
      }
    }
    
    mergeInfo[field] = rowspans;
  });
  
  // 返回 span-method 函数
  return function({ rowIndex, column }) {
    const fieldName = column?.property || column?.field;
    
    if (fieldName && mergeFields.includes(fieldName)) {
      const rowspan = mergeInfo[fieldName][rowIndex];
      
      if (rowspan > 0) {
        return { rowspan, colspan: 1 };
      } else if (rowspan === -1) {
        return { rowspan: 0, colspan: 0 };
      }
    }
    
    return { rowspan: 1, colspan: 1 };
  };
}

/**
 * 计算表格各行占总数的百分比，并对原始数值进行千分位格式化
 * @param {Array} tableData - 表格数据，格式为对象数组
 * @param {Array} calcColumns - 需要计算占比的列名列表
 * @param {Array} resultColumns - 计算结果列名列表，与calcColumns一一对应
 * @param {boolean} showTotalRow - 是否显示合计行，默认为false
 * @returns {Array} - 添加了计算结果的完整表格数据，如果showTotalRow为true则包含合计行
 */
export function calPercent(tableData, calcColumns, resultColumns, showTotalRow = false) {
    // 参数校验
    if (!Array.isArray(tableData) || tableData.length === 0) {
        console.warn('表格数据为空或格式错误');
        return showTotalRow ? [] : tableData;
    }
    
    if (!Array.isArray(calcColumns) || calcColumns.length === 0) {
        console.warn('计算列名为空');
        return showTotalRow ? [] : tableData;
    }
    
    if (!Array.isArray(resultColumns) || resultColumns.length !== calcColumns.length) {
        console.warn('结果列名数量与计算列名数量不匹配');
        return showTotalRow ? [] : tableData;
    }
    
    // 第一步：计算每一列的总和
    const columnSums = {};
    
    calcColumns.forEach(column => {
        columnSums[column] = 0;
    });
    
    tableData.forEach(row => {
        calcColumns.forEach(column => {
            const value = parseFloat(row[column]);
            if (!isNaN(value)) {
                columnSums[column] += value;
            }
        });
    });
    
    // 第二步：为每一行计算百分比并添加到新列，同时对原始数据进行千分位格式化
    const resultTableData = tableData.map(row => {
        const newRow = { ...row };
        
        calcColumns.forEach((calcColumn, index) => {
            const resultColumn = resultColumns[index];
            const sum = columnSums[calcColumn];
            
            // 对原始数据进行千分位格式化
            if (newRow[calcColumn] !== undefined && newRow[calcColumn] !== null) {
                const originalValue = parseFloat(newRow[calcColumn]);
                if (!isNaN(originalValue)) {
                    // 使用您提供的formatNumber函数进行格式化
                    newRow[calcColumn] = formatNumber(originalValue);
                }
            }
            
            if (sum === 0) {
                // 如果总和为0，百分比设为0
                newRow[resultColumn] = '0.00%';
            } else {
                const value = parseFloat(row[calcColumn]) || 0;
                const percentage = (value / sum) * 100;
                
                // 格式化百分比，保留两位小数
                newRow[resultColumn] = percentage.toFixed(2) + '%';
            }
        });
        
        return newRow;
    });
    
    // 第三步：如果需要添加合计行
    if (showTotalRow) {
        // 创建合计行对象
        const totalRow = {};
        
        // 获取第一行的所有键（包括非计算列）
        const firstRow = tableData[0];
        const allKeys = Object.keys(firstRow);
        
        // 遍历所有列，设置合计行的值
        allKeys.forEach(key => {
            if (calcColumns.includes(key)) {
                // 如果是计算列，显示合计值并格式化
                totalRow[key] = formatNumber(columnSums[key]);
            } else if (resultColumns.includes(key)) {
                // 如果是百分比列，合计行显示100%
                totalRow[key] = '100.00%';
            } else {
                // 其他列，如果是首行，显示"合计"，否则设为空或原始值
                if (allKeys.indexOf(key) === 0) {
                    // 假设第一列是名称列，显示"合计"
                    totalRow[key] = '合计';
                } else {
                    // 其他非计算列设为空
                    totalRow[key] = '—';
                }
            }
        });
        
        // 还需要处理百分比列（因为百分比列可能在原始数据中不存在）
        resultColumns.forEach(resultColumn => {
            // 如果这个百分比列不在原始数据的键中，单独添加
            if (!allKeys.includes(resultColumn)) {
                totalRow[resultColumn] = '100.00%';
            }
        });
        
        // 添加合计行标识，用于rowClassName函数识别
        totalRow.isTotal = true;
        
        // 将合计行添加到结果数据中
        resultTableData.push(totalRow);
    }
    
    return resultTableData;
}

/**
 * 表格数据分组汇总函数
 * @param {Array} tableData - 原始表格数据
 * @param {Array} groupFields - 分组字段名列表
 * @param {Array} countFields - 计数字段名列表
 * @param {Array} sumFields - 求和字段名列表
 * @returns {Array} - 分组汇总后的表格数据
 */
export function groupAggregate(tableData, groupFields, countFields, sumFields) {
    // 参数校验
    if (!Array.isArray(tableData) || tableData.length === 0) {
        console.warn('表格数据为空或格式错误');
        return [];
    }
    
    if (!Array.isArray(groupFields) || groupFields.length === 0) {
        console.warn('分组字段为空');
        return tableData;
    }
    
    // 使用Map存储分组结果，key为分组字段组合的字符串
    const groups = new Map();
    
    // 遍历原始数据
    tableData.forEach((row) => {
        // 生成分组key
        const groupKey = groupFields.map(field => {
            const value = row[field];
            return value !== undefined && value !== null ? String(value) : '';
        }).join('|');
        
        // 如果该分组不存在，初始化分组数据
        if (!groups.has(groupKey)) {
            const initialGroup = {};
            
            // 设置分组字段值
            groupFields.forEach(field => {
                initialGroup[field] = row[field];
            });
            
            // 初始化计数字段
            countFields.forEach(field => {
                initialGroup[`${field}_count`] = 0;
            });
            
            // 初始化求和字段
            sumFields.forEach(field => {
                initialGroup[`${field}_sum`] = 0;
            });
            
            groups.set(groupKey, initialGroup);
        }
        
        // 获取当前分组
        const group = groups.get(groupKey);
        
        // 更新计数字段
        countFields.forEach(field => {
            if (row[field] !== undefined && row[field] !== null && row[field] !== '') {
                group[`${field}_count`] += 1;
            }
        });
        
        // 更新求和字段
        sumFields.forEach(field => {
            const value = parseFloat(row[field]);
            if (!isNaN(value)) {
                group[`${field}_sum`] += value;
            }
        });
    });
    
    // 转换Map为数组结果
    const result = Array.from(groups.values());
    
    // 处理求和字段
    result.forEach(group => {
        sumFields.forEach(field => {
            const sumValue = group[`${field}_sum`];
            
            // 求和字段保留两位小数
            if (sumValue !== undefined) {
                group[`${field}_sum`] = Number(sumValue.toFixed(2));
            }
        });
    });
    
    return result;
}